import * as Type from './actionsTypes';

const createOlerite = (data, callback) => ({ type: Type.OLERITE_CREATE, data, callback });

const oleriteClearSelected = () => ({ type: Type.OLERITE_CLEAR_SELECTED });

const updateOlerite = (id, data, callback) => ({ type: Type.OLERITE_UPDATE, id, data, callback });

const findOleriteById = (id) => ({ type: Type.OLERITE_FIND_ONE, id });

const deleteOlerite = (id, callback) => ({ type: Type.OLERITE_DELETE, id, callback });

export {
  createOlerite,
  oleriteClearSelected,
  findOleriteById,
  updateOlerite,
  deleteOlerite,
};
